// frontend/src/components/dashboard/MyDashboard.js
// The "My Dashboard" panel from the spec: assigned / completed / pending /
// overdue / average completion, plus the status pie chart.
import React from 'react';
import { Paper, Grid, Typography, Box, Skeleton } from '@mui/material';
import {
    Inventory, Assignment, CheckCircle, PendingActions, Warning, FactCheck,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const StatTile = ({ icon, label, value, color, onClick, suffix }) => (
    <Paper
        onClick={onClick}
        sx={{
            p: 2, height: '100%', cursor: onClick ? 'pointer' : 'default',
            borderLeft: `4px solid ${color}`,
            transition: 'transform .15s, box-shadow .15s',
            '&:hover': onClick ? { transform: 'translateY(-2px)', boxShadow: 4 } : {},
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, color }}>
            {icon}
            <Typography variant="body2" color="text.secondary" noWrap>{label}</Typography>
        </Box>
        <Typography variant="h4" fontWeight={700}>
            {value}{suffix}
        </Typography>
    </Paper>
);

const MyDashboard = ({ data, loading }) => {
    const navigate = useNavigate();

    if (loading && !data) {
        return (
            <Grid container spacing={2}>
                {[...Array(6)].map((_, i) => (
                    <Grid item xs={12} sm={6} md={2} key={i}>
                        <Skeleton variant="rounded" height={104} />
                    </Grid>
                ))}
            </Grid>
        );
    }

    const d = data || {};

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={2}>
                    <StatTile icon={<Inventory />} label="Total Parts"
                        value={d.total_parts ?? 0} color="#5e35b1"
                        onClick={() => navigate('/parts')} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <StatTile icon={<Assignment />} label="Assigned Parts"
                        value={d.assigned_parts ?? 0} color="#1e88e5"
                        onClick={() => navigate('/parts')} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <StatTile icon={<CheckCircle />} label="Completed"
                        value={d.completed ?? 0} color="#43a047"
                        onClick={() => navigate('/parts?status=Completed')} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <StatTile icon={<PendingActions />} label="Pending"
                        value={d.pending ?? 0} color="#fb8c00" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <StatTile icon={<Warning />} label="Overdue"
                        value={d.overdue ?? 0} color="#e53935"
                        onClick={() => navigate('/parts?overdue=true')} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <StatTile icon={<FactCheck />} label="Average Completion"
                        value={d.average_completion ?? 0} suffix="%" color="#00897b" />
                </Grid>
            </Grid>
        </Box>
    );
};

export default MyDashboard;
